// src/pages/ExitoTurnoAsignado.js
import React, { useEffect, useCallback } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { CheckCircle as CheckIcon } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';

const ExitoTurnoAsignado = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { nombrePaciente, qrCode, numeroTurno } = location.state || {};

  const redirectToScanner = useCallback(() => {
    navigate('/recepcion-escanner', { replace: true });
  }, [navigate]);

  // --- LÓGICA DE VOZ FEMENINA MEJORADA (ES-MX, Google, Microsoft) ---
  useEffect(() => {
    if (!nombrePaciente || !numeroTurno) return;

    const hablar = () => {
      window.speechSynthesis.cancel();

      const texto = `Bienvenido, ${nombrePaciente}. Tu turno es el número ${String(numeroTurno).padStart(3, '0')}.`;
      const utterance = new SpeechSynthesisUtterance(texto);

      const voces = window.speechSynthesis.getVoices();

      let voz = voces.find(v => v.lang === 'es-MX' && (v.name.includes('Female') || v.name.includes('Google')));
      if (!voz) {
        voz = voces.find(v => 
          v.lang.startsWith('es') && 
          (v.name.includes('Female') || v.name.includes('Zira') || v.name.includes('Google') || v.name.includes('Sabina'))
        );
      }
      if (!voz) {
        voz = voces.find(v => v.lang.startsWith('es'));
      }

      if (voz) {
        utterance.voice = voz;
        utterance.rate = 0.95;
        utterance.pitch = 1.05;
        utterance.lang = voz.lang;
      } else {
        utterance.lang = 'es-ES';
      }

      window.speechSynthesis.speak(utterance);
    };

    if (window.speechSynthesis.getVoices().length === 0) {
      window.speechSynthesis.onvoiceschanged = () => setTimeout(hablar, 300);
    } else {
      setTimeout(hablar, 300);
    }

    return () => window.speechSynthesis.cancel();
  }, [nombrePaciente, numeroTurno]);


  // Redirección automática después de 8 segundos
useEffect(() => {
  const timer = setTimeout(() => {
    navigate('/recepcion-escanner', { replace: true });
  }, 8000);

  // Limpieza del timer si el usuario sale antes
  return () => clearTimeout(timer);
}, [navigate]);

  if (!qrCode || !numeroTurno) {
    return (
      <Box sx={{ p: 3, pt: 8, display: 'flex', justifyContent: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
        <Typography color="error">Error: datos de turno incompletos</Typography>
      </Box>
    );
  }

  const handleGoToQueue = () => {
    navigate('/cola-consultorio-servicio'); 
  };

  return (
    <Box sx={{ p: 3, pt: 8, display: 'flex', justifyContent: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Paper elevation={3} sx={{ p: 5, textAlign: 'center', maxWidth: 500, borderRadius: 2 }}>
        
        <Box sx={{ mb: 3 }}>
          <CheckIcon sx={{ fontSize: 120, color: '#4caf50' }} />
        </Box>

        <Typography variant="h5" color="success.main" gutterBottom>
          ¡Paciente Registrado!
        </Typography>

        <Typography variant="body1" sx={{ mb: 1 }}>
          Bienvenido, <strong>{nombrePaciente || 'Paciente'}</strong>
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Código QR: {qrCode}
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          Tu turno asignado es:
        </Typography>

        <Typography variant="h3" color="primary" sx={{ mb: 4, fontWeight: 'bold' }}>
          {String(numeroTurno).padStart(3, '0')}
        </Typography>

        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToQueue}
          size="large"
        >
          Ver Cola de Espera
        </Button>

        <Button
          variant="outlined"
          color="secondary"
          onClick={redirectToScanner} // Permite al usuario saltar la espera
          size="large"
          sx={{ ml: 2 }}
        >
          Escanear Inmediatamente
        </Button>

      </Paper>
    </Box>
  );
};

export default ExitoTurnoAsignado;